import type { ExperienceItem } from '../components/ui/horizontal-experience';

export const experiences: ExperienceItem[] = [
  {
    slug: 'ai-engineer',
    year: '2023–24',
    title: 'AI Engineer',
    role: 'Tech Startup',
    logo: '',
    description: 'Built and shipped production AI features at an early-stage startup — ranging from LLM-powered workflows to retrieval-augmented pipelines that cut manual ops by 60%.',
    projects: [
      { name: 'AI Chat Assistant', description: 'Designed and deployed a context-aware chatbot using GPT-4 with tool-use and memory, integrated into the core product for 10k+ users.' },
      { name: 'RAG Document Pipeline', description: 'Built a retrieval-augmented generation system over internal knowledge bases, reducing support ticket volume by 40%.' },
      { name: 'Prompt Management System', description: 'Created an internal prompt versioning and A/B testing platform, enabling rapid iteration on AI features without redeployment.' },
    ],
  },
  {
    slug: 'full-stack-dev',
    year: '2022–23',
    title: 'Full Stack Dev',
    role: 'Digital Agency',
    logo: '',
    description: 'Delivered end-to-end web products for a portfolio of agency clients — from e-commerce platforms to marketing microsites — in fast-turnaround sprint cycles.',
    projects: [
      { name: 'E-commerce Replatform', description: 'Migrated a legacy WooCommerce store to a Next.js + Shopify Storefront API stack, improving page load by 3× and conversion by 18%.' },
      { name: 'CMS-Driven Marketing Site', description: 'Built a headless CMS system (Sanity + React) for a B2B SaaS client, allowing the marketing team to ship pages without engineering.' },
    ],
  },
  {
    slug: 'junior-dev',
    year: '2021–22',
    title: 'Junior Dev',
    role: 'Web Solutions Inc',
    logo: '',
    description: 'First full-time engineering role — contributed across a Node.js + React monorepo, fixing bugs, shipping features, and learning the ropes of production systems.',
    projects: [
      { name: 'Client Dashboard Overhaul', description: 'Redesigned and rebuilt the analytics dashboard for a fleet-management SaaS, going from jQuery to React and halving render times.' },
      { name: 'REST API Expansion', description: 'Added 12 new endpoints to an Express API to support a mobile app launch, including auth flows and rate limiting.' },
    ],
  },
  {
    slug: 'frontend-intern',
    year: '2020–21',
    title: 'Frontend Intern',
    role: 'Creative Studio',
    logo: '',
    description: 'Worked alongside designers to bring motion-rich creative concepts to life in the browser — heavy use of GSAP, Three.js, and CSS animation.',
    projects: [
      { name: 'Interactive Brand Launch', description: 'Built an award-nominated interactive microsite for a global brand launch with scroll-driven 3D scenes in Three.js.' },
      { name: 'Component Library', description: 'Created a shared component library used across 4 client projects, reducing frontend setup time by 2 weeks per project.' },
    ],
  },
  {
    slug: 'freelance-developer',
    year: '2019–20',
    title: 'Freelance Developer',
    role: 'Self Employed',
    logo: '',
    description: 'Ran a small freelance practice building websites and tools for local businesses and startups — sole point of contact from discovery through launch.',
    projects: [
      { name: 'Restaurant Booking System', description: 'Built a custom reservations and waitlist app for a local restaurant group, replacing a third-party tool and saving £4k/year in fees.' },
      { name: 'Portfolio Sites × 8', description: 'Designed and developed personal portfolio sites for photographers, architects, and creatives — all mobile-first, performance-optimised.' },
    ],
  },
  {
    slug: 'student-researcher',
    year: '2018–19',
    title: 'Student Researcher',
    role: 'University Lab',
    logo: '',
    description: 'Undergraduate research placement in a human-computer interaction lab — ran user studies and prototyped experimental interfaces for accessibility research.',
    projects: [
      { name: 'Gaze-Controlled Interface', description: 'Prototyped an eye-tracking navigation system for users with motor impairments, presented at a departmental symposium.' },
      { name: 'Accessibility Audit Tooling', description: 'Wrote a Python script to batch-audit university web pages against WCAG 2.1 AA, identifying 200+ violations for remediation.' },
    ],
  },
];
